 
import IndexModel from "@/service/v10/sigap/IndexModel";
 
class FaltaService extends IndexModel { 
       
    constructor() {
        super();
        this.url =  this.url + '/Falta' ;  
    }
 
    public getApiUrl(  ) { 
        return this.getAxios().defaults.baseURL + this.url; 
    }
 
    public getModel( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
    
     
    public getStatus( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetStatus'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
    
    public getMotivo( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetMotivo'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }

    
    public getTipo( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetTipo'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }

    
    public GetSituacao( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetSituacao'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }

}
  
export default FaltaService; 